import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { EduProjectViolationService } from 'src/app/service/context/edu/edu-project-violation.service';

@Component({
    selector: 'app-edu-project-violation-edit',
    templateUrl: './edu-project-violation-edit.component.html',
    styles: []
})
export class EduProjectViolationEditComponent implements OnInit {
    constructor(
        private eduProjectViolationService: EduProjectViolationService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        public datePipe: DatePipe,
        private router: Router,
    ) { }

    // Cơ bản
    host: string;
    guid: string;
    eduProjectViolation: any = {};

    // Phê duyệt
    comment: string;
    modalRef: BsModalRef;
    isApproving: boolean = false;

    ngOnInit() {
        this.guid = this.route.snapshot.paramMap.get('guid');
        this.host = this.eduProjectViolationService.BaseHost;

        if (this.guid)
            this.loadData();
    }

    loadData() {
        this.eduProjectViolationService.getEduProjectViolationById(this.guid).subscribe(
            res => {
                if (!res)
                    this.router.navigateByUrl('/techbyte/admin/error');
                
                this.eduProjectViolation = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onCancel() {
        this.router.navigateByUrl('/techbyte/admin/edu-project-violation');
    }

    // Phê duyệt
    onApprove(template: TemplateRef<any>) {
        this.comment = '';
        this.modalRef = this.modalService.show(template);
        this.isApproving = true;
    }

    onReject(template: TemplateRef<any>) {
        this.comment = '';
        this.modalRef = this.modalService.show(template);
        this.isApproving = false;
    }

    onDoneApproval() {
        if (this.isApproving == false && this.comment.length == 0) {
            this.toastr.error("Ý kiến người xử lý không được để trống", 'Lỗi.');
            return;
        }

        let approvalItem = {
            guid: this.guid,
            comment: this.comment,
            isApproving: this.isApproving,
        };
        this.eduProjectViolationService.approvalEduProjectViolation(approvalItem).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.modalRef.hide();
                window.location.reload();
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }
}